import ajax from '@/utils/ajax';
// 4870367778182072320
export const head = '/web';

export const getActiveDetail = (data) => ajax(
  `${head}/v1/daka/activity/data?activityId=${data.activityId}&isPreview=${data.isPreview}`,
  {},
  'POST',
);

export const getPrizeDetail = (data) => ajax(
  `${head}/v1/daka/activity/prize/${data.activityId}/${data.activityPrizeId}`,
  {},
  'POST',
);

export const givePrize = (data) => ajax(
  `${head}/v1/daka/activity/receive/prize`,
  data,
  'POST',
);

export const givePrizeHelpStatus = (activityId, userId) => ajax(
  `${head}/v1/daka/activity/help-check/${activityId}/${userId}`,
  {},
  'POST',
);

export const givePrizeHelpAdd = (activityId, userId) => ajax(
  `${head}/v1/daka/activity/help/${activityId}/${userId}`,
  {},
  'POST',
);

// 报名
export const signUp = (activityId) => ajax(
  `${head}/v1/daka/activity/sign/${activityId}`,
  {},
  'POST',
);

// 补卡
export const onBuka = (data) => ajax(
  `${head}/v1/daka/record/save/${0}`,
  data,
  'POST',
);